import { useEffect, useState } from 'react';
import { OperationProgressWindowRequest } from '../../../shared/ui/progress';
import type { ValidationRunProgress } from '../lib/validationRunProgress';
import { buildValidationRunProgressModel } from '../lib/validationOperationProgress';

interface ValidationRunProgressWindowRequestProps {
  progress: ValidationRunProgress;
}

function useValidationRunProgressModel(progress: ValidationRunProgress) {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (progress.phase === 'complete' || progress.phase === 'cache-hit' || progress.phase === 'error') {
      return undefined;
    }

    const timer = window.setInterval(() => {
      setNow(Date.now());
    }, 1000);

    return () => window.clearInterval(timer);
  }, [progress.phase]);

  return buildValidationRunProgressModel(progress, now);
}

export default function ValidationRunProgressWindowRequest({
  progress,
}: ValidationRunProgressWindowRequestProps) {
  const model = useValidationRunProgressModel(progress);

  return (
    <OperationProgressWindowRequest
      id="pcf-validation-run-progress"
      open
      model={model}
      priority={50}
      maxWidth="sm"
    />
  );
}
